/*
 * @Descripttion: 
 * @version: 
 * @Author: yenible
 * @Date: 2024-04-05 21:06:31
 */
import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: HomeView
    },
    {
      path: '/messagesend',
      name: 'messagesend',
      component: () => import('../views/MessageSendView.vue')
    },
    {
      path: '/numverify',
      name: 'numverify',
      component: () => import('../views/NumVerifyView.vue')
    },
    {
      path: '/contactus',
      name: 'contact',
      component: () => import('../views/ContactView.vue')
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: () => import('../views/aboutUsView.vue')
    },
    {
      path: '/flashLetter',
      name: 'flashLetter',
      component: () => import('../views/flashLetterView.vue')
    },
    {
      path: '/smsverify',
      name: 'smsverify',
      component: () => import('../views/SMSVerifyView.vue')
    }
  ]
})

router.afterEach(() => {
  window.scrollTo(0, 0); // 滚动到页面的左上角
})

export default router
